var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MallDepartment",staticStyle:{"text-align":"center"}},[_vm._v(" 商城部-暂无数据 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }